import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * When working with random values in expressions, we want to preserve their stability across calculation trees.
 * Therefore, we store the results of random calculations here and reuse them inside rendered expressions.
 * This store is only used in the modelling views; during simulations, the random values are stored in the simulation rounds instead.
 */
export const useRandomValuesStore = defineStore("ui/randomValues", () => {
  /**
   * The random values are stored in a key-value pair, where the key is a string that uniquely identifies the random value.
   * Key format: `object_uid.0.1.0.1.1` <- path to sub-calculation in the expression tree
   */
  const randomValues = ref<{ [key: string]: number }>({});

  function reset() {
    randomValues.value = {};
  }

  return {
    randomValues,
    reset
  };
});
